import {useState, useEffect} from "react";
import "../styles/background.css";
import video from "../assets/neural-bg-loop.mp4";
import fallbackImage from "../assets/neural-bg-fallback.png";
import avatarImage from "../assets/self_illust.png";
import avatarVideo from "../assets/self_illust_vid.webm";
import nyarucchi_smile from "../assets/nyarucchi_smile.png";
import nyarucchi_laugh from "../assets/nyarucchi_laugh.png";

import "../styles/avatar.css";

const Background = ({ page }) => {
  const avatarClass = `avatar ${page}`;
  const [showLaugh, setShowLaugh] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowLaugh((prev) => !prev);
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <video autoPlay muted loop playsInline className={avatarClass}>
        <source src={avatarVideo} type="video/webm" />
        <img src={avatarImage} alt="avatar fallback" />
        Your browser does not support the video tag.
      </video>
      <img
        src={showLaugh ? nyarucchi_laugh : nyarucchi_smile}
        alt="Nyarucchi"
        className="nyarucchi"
      />
      <div className="shadow-overlay"></div>
      <video
        playsInline
        autoPlay
        muted
        loop
        preload="auto"
        id="bg"
        poster={fallbackImage}
      >
        <source src={video} type="video/mp4" />
      </video>
    </>
  );
};

export default Background;
